import React, { useState } from "react";
import { toast } from "react-toastify";

const TaskCompletionDetails = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [taskTitle, setTaskTitle] = useState("");

  const openModal = (title) => {
    setTaskTitle(title);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const markAsCompleted = () => {
    toast.success("Task marked as completed.", { autoClose: 3000 });
    closeModal();
  };

  const editTask = () => {
    toast.info("Editing task...", { autoClose: 3000 });
    closeModal();
  };

  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "#eaedf2",
        fontFamily: "Poppins, sans-serif",
        minHeight: "100vh",
      }}
    >
      {/* Header Section */}
      <header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <h1
          style={{ fontSize: "1.5rem", fontWeight: "bold", color: "#2d3748" }}
        >
          Task Completion Details
        </h1>
        <nav style={{ color: "#718096" }}>
          <span>
            Dashboard {">"} VC Performance Dashboard {">"} Task Completion
            Details
          </span>
          <input
            type="text"
            placeholder="Search..."
            style={{
              marginLeft: "10px",
              padding: "8px",
              borderRadius: "4px",
              border: "1px solid #e2e8f0",
            }}
          />
          <input
            type="date"
            style={{
              marginLeft: "10px",
              padding: "8px",
              borderRadius: "4px",
              border: "1px solid #e2e8f0",
            }}
          />
        </nav>
      </header>

      {/* Filters Panel */}
      <div
        style={{
          backgroundColor: "#ffffff",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
          padding: "20px",
          marginBottom: "20px",
        }}
      >
        <h2
          style={{
            fontSize: "1.25rem",
            fontWeight: "600",
            marginBottom: "15px",
          }}
        >
          Filters
        </h2>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: "15px",
          }}
        >
          <select
            style={{
              padding: "8px",
              borderRadius: "4px",
              border: "1px solid #e2e8f0",
            }}
          >
            <option>State</option>
            <option>State 1</option>
            <option>State 2</option>
          </select>
          <select
            style={{
              padding: "8px",
              borderRadius: "4px",
              border: "1px solid #e2e8f0",
            }}
          >
            <option>District</option>
            <option>District 1</option>
            <option>District 2</option>
          </select>
          <select
            style={{
              padding: "8px",
              borderRadius: "4px",
              border: "1px solid #e2e8f0",
            }}
          >
            <option>VC Name</option>
            <option>VC 1</option>
            <option>VC 2</option>
          </select>
          <select
            style={{
              padding: "8px",
              borderRadius: "4px",
              border: "1px solid #e2e8f0",
            }}
          >
            <option>Task Type</option>
            <option>Guest Lectures</option>
            <option>Industry Visits</option>
          </select>
          <select
            style={{
              padding: "8px",
              borderRadius: "4px",
              border: "1px solid #e2e8f0",
            }}
          >
            <option>Completion Status</option>
            <option>All</option>
            <option>Completed</option>
            <option>Pending</option>
            <option>Overdue</option>
          </select>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gridColumn: "span 2",
            }}
          >
            <span>Task Priority:</span>
            <div style={{ display: "flex", alignItems: "center" }}>
              <label style={{ marginRight: "10px" }}>
                <input type="radio" name="priority" value="low" /> Low
              </label>
              <label style={{ marginRight: "10px" }}>
                <input type="radio" name="priority" value="medium" /> Medium
              </label>
              <label>
                <input type="radio" name="priority" value="high" /> High
              </label>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "20px",
          }}
        >
          <button
            style={{
              backgroundColor: "#4299e1",
              color: "white",
              padding: "10px 15px",
              border: "none",
              borderRadius: "4px",
            }}
          >
            Apply Filters
          </button>
          <button
            style={{
              backgroundColor: "#e2e8f0",
              color: "#718096",
              padding: "10px 15px",
              border: "none",
              borderRadius: "4px",
              marginLeft: "10px",
            }}
          >
            Reset Filters
          </button>
        </div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, minmax(200px, 1fr))",
          gap: "20px",
          marginBottom: "20px",
        }}
      >
        <div
          style={{
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            height: "120px",
            width: "100%",
          }}
        >
          <h2 style={{ fontSize: "18px", fontWeight: "600" }}>
            Total Tasks Assigned
          </h2>
          <p style={{ fontSize: "24px", fontWeight: "300", color: "#007BFF" }}>
            50
          </p>
        </div>
        <div
          style={{
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            height: "120px",
            width: "100%",
          }}
        >
          <h2 style={{ fontSize: "18px", fontWeight: "600" }}>
            Tasks Completed On-Time
          </h2>
          <p style={{ fontSize: "24px", fontWeight: "300", color: "#28a745" }}>
            35
          </p>
        </div>
        <div
          style={{
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            height: "120px",
            width: "100%",
          }}
        >
          <h2 style={{ fontSize: "18px", fontWeight: "600" }}>Overdue Tasks</h2>
          <p style={{ fontSize: "24px", fontWeight: "300", color: "red" }}>5</p>
        </div>
        <div
          style={{
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            height: "120px",
            width: "100%",
          }}
        >
          <h2 style={{ fontSize: "18px", fontWeight: "600" }}>Pending Tasks</h2>
          <p style={{ fontSize: "24px", fontWeight: "300", color: "#FFC107" }}>
            10
          </p>
        </div>
        <div
          style={{
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            height: "120px",
            width: "100%",
          }}
        >
          <h2 style={{ fontSize: "18px", fontWeight: "600" }}>
            Average Time for Task Completion
          </h2>
          <p style={{ fontSize: "24px", fontWeight: "300", color: "#007BFF" }}>
            3 Days
          </p>
        </div>
      </div>

      {/* Task Completion Details Table */}
      <div
        style={{
          backgroundColor: "#ffffff",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
          padding: "20px",
        }}
      >
        <h2
          style={{
            fontSize: "1.25rem",
            fontWeight: "600",
            marginBottom: "15px",
          }}
        >
          Task Completion Details
        </h2>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            border: "1px solid #e2e8f0",
          }}
        >
          <thead>
            <tr style={{ backgroundColor: "#edf2f7" }}>
              <th style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                S.No
              </th>
              <th style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                Task Title
              </th>
              <th style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                Task Type
              </th>
              <th style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                State
              </th>
              <th style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                District
              </th>
              <th style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                VC Name
              </th>
              <th style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                Start Date
              </th>
              <th style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                End Date
              </th>
              <th style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                Completion Date
              </th>
              <th style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                Status
              </th>
              <th style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                Remarks
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                1
              </td>
              <td
                style={{
                  padding: "10px",
                  border: "1px solid #e2e8f0",
                  cursor: "pointer",
                }}
                onClick={() => openModal("Task 1")}
              >
                Task 1
              </td>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                Guest Lecture
              </td>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                State 1
              </td>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                District 1
              </td>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                VC 1
              </td>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                01/01/2023
              </td>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                01/15/2023
              </td>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                01/10/2023
              </td>
              <td
                style={{
                  padding: "10px",
                  border: "1px solid #e2e8f0",
                  color: "#48bb78",
                }}
              >
                Completed
              </td>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                N/A
              </td>
            </tr>
            <tr>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                2
              </td>
              <td
                style={{
                  padding: "10px",
                  border: "1px solid #e2e8f0",
                  cursor: "pointer",
                }}
                onClick={() => openModal("Task 2")}
              >
                Task 2
              </td>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                Industry Visit
              </td>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                State 2
              </td>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                District 2
              </td>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                VC 2
              </td>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                01/05/2023
              </td>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                01/20/2023
              </td>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                N/A
              </td>
              <td
                style={{
                  padding: "10px",
                  border: "1px solid #e2e8f0",
                  color: "#f56565",
                }}
              >
                Overdue
              </td>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                Delay in approval
              </td>
            </tr>
          </tbody>
        </table>
        <div style={{ marginTop: "20px" }}>
          <button
            style={{
              backgroundColor: "#007BFF",
              color: "#fff",
              padding: "10px 20px",
              border: "none",
              borderRadius: "5px",
              marginRight: "10px",
            }}
          >
            Export as CSV
          </button>
          <button
            style={{
              backgroundColor: "#007BFF",
              color: "#fff",
              padding: "10px 20px",
              border: "none",
              borderRadius: "5px",
              marginRight: "10px",
            }}
          >
            Export as PDF
          </button>
        </div>
      </div>

      {/* Task Details Modal */}
      {isModalOpen && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "8px",
              padding: "20px",
              width: "30%",
            }}
          >
            <h2
              style={{
                fontSize: "1.25rem",
                fontWeight: "600",
                marginBottom: "15px",
              }}
            >
              {taskTitle}
            </h2>
            <p>
              <strong>Task Type:</strong> Task Type
            </p>
            <p>
              <strong>VC Details:</strong> VC Details
            </p>
            <p>
              <strong>Task Dates:</strong>
            </p>
            <p>Start Date: Start Date</p>
            <p>Due Date: Due Date</p>
            <p>Completion Date: Completion Date</p>
            <p>
              <strong>Task Description:</strong>
            </p>
            <p>Detailed description of the task.</p>
            <p>
              <strong>Attachments:</strong>
            </p>
            <ul>
              <li>
                <a href="#" style={{ color: "#3182ce" }}>
                  Attachment 1
                </a>
              </li>
              <li>
                <a href="#" style={{ color: "#3182ce" }}>
                  Attachment 2
                </a>
              </li>
            </ul>
            <p>
              <strong>Performance Insight:</strong>
            </p>
            <p>Time taken: X days</p>
            <p>Delays: None</p>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "20px",
              }}
            >
              <button
                style={{
                  backgroundColor: "#48bb78",
                  color: "white",
                  padding: "10px 15px",
                  borderRadius: "4px",
                }}
                onClick={markAsCompleted}
              >
                Mark as Completed
              </button>
              <button
                style={{
                  backgroundColor: "#f6ad55",
                  color: "white",
                  padding: "10px 15px",
                  borderRadius: "4px",
                  marginLeft: "10px",
                }}
                onClick={editTask}
              >
                Edit Task
              </button>
              <button
                style={{
                  backgroundColor: "#e53e3e",
                  color: "white",
                  padding: "10px 15px",
                  borderRadius: "4px",
                  marginLeft: "10px",
                }}
                onClick={closeModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TaskCompletionDetails;
